const readCookie = (name: string): string | undefined =>
  document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')[1];

const generateEventId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

/**
 * Fires the client-side Pixel `Lead` event and returns the fields needed for
 * the matching server-side Conversions API event (funwooApis `mail/sendMail`),
 * sharing one eventId between the two so Meta dedupes them.
 */
export const trackLead = () => {
  const eventId = generateEventId();

  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'Lead', {}, { eventID: eventId });
  }

  return {
    eventId,
    fbc: readCookie('_fbc'),
    fbp: readCookie('_fbp'),
    eventSourceUrl: typeof window !== 'undefined' ? window.location.href : undefined,
  };
};
